import React from 'react';
import Attendance_Remark from './Attendance_Remark';
import '../../../CommonCSS/SocietyCSS.css'

const Attendance_RemarkApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Attendance/Remark</h5>
          </div>  
        </div>
        <Attendance_Remark/>
      </div>
    </div >
  );
};

export default Attendance_RemarkApp;
